/* istanbul ignore file: most helprs to be deleted */
import { UiRegionItem } from 'utils/cfUiItems/base';
import { makeUID } from 'utils/strings/strings';
import { getPointRegionInfo, isPointUIRegionItem } from 'utils/annotations/point';

export const getRegionInfo = (region: UiRegionItem): CF.API.RegionInfo | null => {
  if ('bbox' in region.regionData) {
    return {
      bounding_box: region.regionData.bbox,
    };
  }

  if ('polygon' in region.regionData) {
    return {
      polygon: region.regionData.polygon,
    };
  }

  if (isPointUIRegionItem(region.regionData)) {
    return getPointRegionInfo(region.regionData);
  }

  return null;
};

export const getAnnotationsFromRegions = (regions: UiRegionItem[], inputId: string, userId?: string): CF.API.Annotations.Annotation[] => {
  const batchOfAnnotations: CF.API.Annotations.Annotation[] = [];

  regions.forEach((region) => {
    const regionInfo = getRegionInfo(region);

    if (regionInfo) {
      batchOfAnnotations.push({
        data: {
          regions: [
            {
              id: region.key,
              data: {
                concepts: region.concepts,
              },
              region_info: regionInfo,
            },
          ],
        },
        id: makeUID(),
        input_id: inputId,
        worker: userId
          ? {
              user: {
                id: userId,
              } as CF.API.Users.User,
            }
          : undefined,
      });
    }
  });
  return batchOfAnnotations;
};
